import { get, post } from '@/helpers/requests';
import router from '@/router';
import i18n from '@/plugins/i18n';

const methods = {
    get,
    post
};

/**
 * [function]
 * Comportamento default do forgot & reset password.
 * O comportamento lógico destas duas acções é exactamente igual, onde
 * só muda o método.
 * Forgot = get
 * Reset = post
 *
 * @param {Function} commit
 * @param {Object} formData
 * @param {String} method
 * @since 1.1.0.
 * @category function
 * @author Tiago Martinho
 *
 */
const handlerRequestPassword = async ({ commit, formData, method = 'get' }) => {
    commit( 'TOGGLE_LOADING', true );
    await methods[method]( '/auth/reset-password', formData )
        .then( ({ data }) => {
            commit( 'MANAGE_RESPONSE', {
                has: true,
                type: 'success',
                message: data.message
            });

            setTimeout( () => {
                router.push({ name: 'login' });
            }, 5000 );
        }, () => {
            commit( 'MANAGE_RESPONSE', {
                has: true,
                type: 'insuccess',
                message: i18n.t( 'error.request' )
            });
        });

    commit( 'TOGGLE_LOADING', false );
};

export default handlerRequestPassword;